import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderComponent} from "../../order-manager/order/order.component";
import {catchError, throwError} from "rxjs";
import {ItemService} from "../../../services-otc/item.service";
import {NavBarComponent} from "../../../../nav-bar/nav-bar.component";

@Component({
    selector: 'app-clear-items',
    templateUrl: './clear-items.component.html',
    styleUrls: ['./clear-items.component.css'],
    standalone: false
})
export class ClearItemsComponent {


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<OrderComponent>,
              private itemService: ItemService,
              public nav: NavBarComponent,
  ) {
  }

  cancelClearingItems(){
    this.dialogRef.close();
  }
  deleteAllItems(){
      if(this.data.items.length !== 0){
          this.nav.toggleLoading(true);
          this.data.items.forEach((result)=> {
              this.itemService.deleteOrderListItemById(result.id).pipe(
                  catchError(error => {
                      console.error(error);
                      return throwError(() => error);
                  })
              ).subscribe(() => {
                  this.dialogRef.close();
              });
          })
      }else{
          this.dialogRef.close();
      }

  }
}
